type StandardReport = {
    dataEndpoint?: string;
    title?: string;
};

type StandardDashboard = {
    signalsObjects: StandardReport[];
};

/**
 * The original name of a report: the title of the report on a standard dashboard that uses the
 * same data endpoint. Standard dashboards are where the Add Cards list gets its reports, so this is
 * the name the report had when it was added, before any rename. Pass the dashboards in
 * `SignalsPageStore.standardDashboards` order so the first match is the one the Add Cards list shows.
 * Cards with no endpoint (text, montage) and endpoints with no standard report return undefined.
 */
export function findStandardReportTitle(
    standardDashboards: readonly StandardDashboard[],
    dataEndpoint: string | undefined,
): string | undefined {
    if (!dataEndpoint) return undefined;

    for (const dashboard of standardDashboards) {
        const match = dashboard.signalsObjects.find(
            (obj) => obj.dataEndpoint === dataEndpoint && obj.title?.trim(),
        );
        if (match) return match.title;
    }

    return undefined;
}
